import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { bonusAssignmentFields } from '../fields';
import { ListBonusAssignmentsResponse, ListBonusAssignmentsVariables } from '../types';

export const listBonusAssignmentsQuery = gql`
  query PayrollListBonusAssignments($input: ListBonusAssignmentsInput!) {
    payrollListBonusAssignments(input: $input) {
      code
      success
      message
      total_count
      limit
      offset
      data {
        ${bonusAssignmentFields}
      }
    }
  }
`;

export const listBonusAssignments = (queryVariables: ListBonusAssignmentsVariables) =>
  graphQLApi<ListBonusAssignmentsResponse, ListBonusAssignmentsVariables>({
    query: listBonusAssignmentsQuery,
    queryVariables,
  });

export default listBonusAssignments;
